import axios from 'axios'

export default {
    get: () => axios.get('kams'),
    store: (data) => axios.post('kams/store', data),
    update: (data) => axios.post('kams/update', data),
    delete: (id) => axios.post('kams/delete', id),
    generateLink: (data) => axios.post('kams/generate-link', data),
    getByChallenge: (challenge_id) => axios.get('challenges/'+challenge_id+'/kams'),
}